import React from 'react';

import useWaitlistAlertSound from './useWaitlistAlertSound';

/**
 * Headless mount point for the "Table Ready" waitlist audio alert. Renders
 * nothing — all behaviour lives in {@link useWaitlistAlertSound}. Mounted once
 * at the app level (alongside SeatOfferTimeoutSnackbar) so the alert is global,
 * single-instance, and independent of which table currently has focus.
 */
const WaitlistAlertSound: React.FC = () => {
  useWaitlistAlertSound();
  return null;
};

export default WaitlistAlertSound;
